<div @moveDown [ngClass]="{ difuminar_Fondo: booCargando }" style="position: relative;">

  <article class="article__info">

    <section class="info">
      <h2 class="colorInge" style="margin-bottom: 2px; margin-top: 2px;">{{ summaries?.name || 'Nombre No Informado' }}</h2>
      <h3 *ngIf="summaries" style="display: inline-block; margin-top: 2px;">
        <span>{{ summaries!.rut }}</span> <br>
        <span>{{ summaries!.economicActivity || 'No presenta Actividad' }}</span>
      </h3>
    </section>

  </article>

  <main @moveDown class="container_minutes_main">

    <div class="contenedor-filtro">
      <app-filter-dashboard-client
        (topFilter)="filterTop($event)"
        (changeClientFileFilter)="receiveUpdatedFilters($event)"
      ></app-filter-dashboard-client>
    </div>
    
    <article class="container_inicadores_section" *ngIf="summaries" style="margin-top: -32px;">
      <div class="">
        <div class="row">
          <div class="col"><h2 class="colorInge">Actividad Comercial</h2></div>
        </div>

        <div class="container">
          <div class="desktop-view">
            
            <div class="row containerCard" *ngIf="this.selectedVal == 'dashboard'">

              <div class="col">
                <section class="section__card cardWithShadow card_Ventas row" style="width: 96%; height: 160px;">
                  <div class="col-md-6">
                    <div class="container_fact_title">
                      <h3 class="colorInge">Ventas</h3>
                      <h3>
                        {{ summaries.sellInvoiceAmount | currency : "CLP" : "symbol" }}
                      </h3> 
                    </div>
                    <div class="container_fact_title">
                      <h3 class="colorInge">Docs</h3>
                      <h3>{{ summaries.numberSellInvoices }}</h3>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="container_fact_title">
                      <h3 class="colorInge">Ventas NC</h3>
                      <h3>
                        {{ summaries.sellCreditNotesAmount | currency : "CLP" : "symbol" }}
                      </h3> 
                    </div>
                    <div class="container_fact_title">
                      <h3 class="colorInge">Docs</h3>
                      <h3>{{ summaries.numberSellCreditNotes }}</h3>
                    </div>
                  </div>
                </section>
              </div>
            
            
              <div class="col">
                <section class="section__card cardWithShadow card_Compras row">
                  <div class="col-md-6">
                    <div class="container_fact_title">
                      <h3 class="colorInge">Compras</h3>
                      <h3>
                        {{ summaries.buyInvoiceAmount | currency : "CLP" : "symbol" }}
                      </h3> 
                    </div>
                    <div class="container_fact_title">
                      <h3 class="colorInge">Docs</h3>
                      <h3>{{ summaries.numberBuyInvoices }}</h3>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="container_fact_title">
                      <h3 class="colorInge">Compras NC</h3>
                      <h3>
                        {{ summaries.buyCreditNotesAmount | currency : "CLP" : "symbol" }}
                      </h3> 
                    </div>
                    <div class="container_fact_title">
                      <h3 class="colorInge">Docs</h3>
                      <h3>{{ summaries.numberBuyCreditNotes }}</h3>
                    </div>
                  </div>
                </section>
              </div>
            
            </div>

          </div>
          <div class="mobile-view">

            <div class="row containerCard" *ngIf="this.selectedVal == 'dashboard'">

              <div class="col">
                <section class="section__card cardWithShadow card_Ventas">
                  <div class="container_fact_title">
                    <h3 class="colorInge">Ventas</h3>
                    <h3>
                      {{ summaries.sellInvoiceAmount | currency : "CLP" : "symbol" }}
                    </h3> 
                  </div>
                  <div class="container_fact_title">
                    <h3 class="colorInge">Docs</h3>
                    <h3>{{ summaries.numberSellInvoices }}</h3>
                  </div>
                </section>
              </div>
              <div class="col">
                <section class="section__card cardWithShadow card_Ventas">
                  <div class="container_fact_title">
                    <h3 class="colorInge">NC Ventas</h3>
                    <h3>
                      {{
                        summaries.sellCreditNotesAmount | currency : "CLP" : "symbol"
                      }}
                    </h3>
                  </div>
                  <div class="container_fact_title">
                    <h3 class="colorInge">Docs</h3>
                    <h3>{{ summaries.numberSellCreditNotes }}</h3>
                  </div>
                </section>
              </div>
              <div class="col">
                <section class="section__card cardWithShadow card_Compras">
                  <div class="container_fact_title">
                    <h3 class="colorInge">Compras</h3>
                    <h3>
                      {{ summaries.buyInvoiceAmount | currency : "CLP" : "symbol" }}
                    </h3>
                  </div>
                  <div class="container_fact_title">
                    <h3 class="colorInge">Docs</h3>
                    <h3>{{ summaries.numberBuyInvoices }}</h3>
                  </div>
                </section>
              </div>
              <div class="col">
                <section class="section__card cardWithShadow card_Compras">
                  <div class="container_fact_title">
                    <h3 class="colorInge">NC Compras</h3>
                    <h3>
                      {{
                        summaries.buyCreditNotesAmount | currency : "CLP" : "symbol"
                      }}
                    </h3>
                  </div>
                  <div class="container_fact_title">
                    <h3 class="colorInge">Docs</h3>
                    <h3>{{ summaries.numberBuyCreditNotes }}</h3>
                  </div>
                </section>
              </div>

            </div>

          </div>
        </div>
        
        <div class="row" *ngIf="this.selectedVal == 'chart'">
          <div class="col">
            <app-activity-summary-chart [dataSource]="this.monthlySummaries"></app-activity-summary-chart>
          </div>
        </div>
      </div>
    </article>
</main>

<br>


<div class="chip-container">
  <mat-chip-set>
    <mat-chip class="chip-with-icon">
      <i-tabler name="layout-dashboard" class="calendar"></i-tabler>
    </mat-chip>
  </mat-chip-set>  &nbsp;&nbsp;

  <div class="chip-options-container">
    <mat-chip-option  style="font-weight: bold;"
    *ngFor="let n of menu; let i = index" 
      [selected]="selectedChipIndex === i"
      (click)="selectChipMenu(i)"
      [ngClass]="{'selected-chip': selectedChipIndex === i, 'disabled': selectedChipIndex === i}">
      <span class="menuSelector">{{ n }}</span>
    </mat-chip-option>
  </div>
</div>

  <hr>
  <br>

  <div class="contenedor_tabs_invoces_detail">
    <div @fadeSlideIn *ngIf="viewInvocesDetail=='TopVentas'">
      <app-top-sell-invoces
        [topSellInvoices]="topSellInvoices"
      ></app-top-sell-invoces>
    </div>
    <div @fadeSlideIn *ngIf="viewInvocesDetail=='TopCompras'">
      <app-top-buy-invoces
        [topBuyInvoices]="topBuyInvoices"
      ></app-top-buy-invoces>
    </div>
    <div @fadeSlideIn *ngIf="viewInvocesDetail=='Ventas'">
      <app-table-sell-invoces
        (pages)="filterPageSizeSellInvoices($event)"
        [sellInvoices]="sellInvoices"
      ></app-table-sell-invoces>
    </div>
    <div @fadeSlideIn *ngIf="viewInvocesDetail=='Compras'">
      <app-table-buy-invoces
        (pages)="filterPageSizeBuyInvoices($event)"
        [buyInvoices]="buyInvoices"
      ></app-table-buy-invoces>
    </div>
  </div>
    
</div>
